const removeTrailingSlash = (value: string) => value.replace(/\/$/, '');

export const getApiBaseUrl = (): string => {
  // Priority 1: Runtime config injected by backend (for Azure deployment)
  if (typeof window !== 'undefined' && (window as any).__BACKEND_BASE_URL__) {
    return removeTrailingSlash((window as any).__BACKEND_BASE_URL__);
  }

  // Priority 2: Build-time environment variable (only for local dev)
  const envUrl = import.meta.env.VITE_API_BASE_URL?.trim();
  if (envUrl) {
    return removeTrailingSlash(envUrl);
  }

  // Priority 3: Infer from current origin (works in production)
  if (typeof window !== 'undefined') {
    return `${removeTrailingSlash(window.location.origin)}/api`;
  }

  return '/api';
};

export const buildApiUrl = (path: string): string => {
  const cleanedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getApiBaseUrl()}${cleanedPath}`;
};
